import { Grid, TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
// @ts-ignore
import MUIEditor from "react-mui-draft-wysiwyg";
import LabelsContext from "../../../lang/LabelsContext";
import { dateTimeView, richTextStateFromHTML } from "../../../utils/Utils";

interface MailViewType {
  mail: any;
  onClose: any;
}

export default function MailView(props: MailViewType) {
  const { mail, onClose } = props;
  const { Labels } = LabelsContext();

  return (
    <Dialog
      open={!!mail}
      onClose={onClose}
      maxWidth={"md"}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Mail</DialogTitle>
      <DialogContent>
        <Grid container direction="column">
          <Grid item>
            <TextField
              variant="outlined"
              margin="normal"
              id="date"
              name="date"
              InputProps={{
                readOnly: true,
              }}
              label={Labels.DATE}
              value={dateTimeView(mail?.timeSent)}
              fullWidth
            />
          </Grid>
          <Grid item>
            <TextField
              variant="outlined"
              margin="normal"
              id="type"
              name="type"
              label={"Type"}
              value={mail?.type}
              InputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
          <Grid item>
            <TextField
              variant="outlined"
              margin="normal"
              id="mailTo"
              name="mailTo"
              label={Labels.TO}
              value={mail?.mailTo}
              InputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
          <Grid item>
            <TextField
              variant="outlined"
              margin="normal"
              id="cc"
              name="cc"
              label={Labels.CC}
              value={mail?.cc}
              InputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
          <Grid item>
            <TextField
              variant="outlined"
              margin="normal"
              id="subject"
              name="subject"
              label={Labels.SUBJECT}
              value={mail?.subject}
              InputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
          {mail?.body && (
            <Grid item>
              <MUIEditor
                config={{
                  toolbar: { controls: [] },
                  draftEditor: {
                    stripPastedStyles: true,
                  },
                }}
                editorState={richTextStateFromHTML(mail.body)}
              />
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary" size="small">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
